'use strict';

import moment from 'moment-timezone';
import i18n from 'i18next';

let componentDatepickerMonthYear = (function () {
  let config = {};
  let currentMonth;
  let currentYear;
  let selectorElement = null;
  let inputElement = null;
  let onDateChangeCallback = null;

  let createSelector = (elementId) => {
    const selector = document.createElement('div');
    selector.id = `${elementId}-selector`;
    selector.className = 'datepicker-month-year__selector';

    // Create months array (abbreviated)
    const months = [
      i18n.t('jan'),
      i18n.t('feb'),
      i18n.t('mar'),
      i18n.t('apr'),
      i18n.t('may'),
      i18n.t('jun'),
      i18n.t('jul'),
      i18n.t('aug'),
      i18n.t('sep'),
      i18n.t('oct'),
      i18n.t('nov'),
      i18n.t('dec'),
    ];

    const currentYearValue = new Date().getFullYear();
    const years = [];
    for (let year = 2015; year <= currentYearValue; year++) {
      years.push(year);
    }

    selector.innerHTML = `
      <span class="datepicker-month-year__triangle"></span>
      <div class="datepicker-month-year__header">
        <button type="button" class="datepicker-month-year__nav-button datepicker-month-year__nav-button--prev" id="${elementId}-prev" title="Prev">
          <span class="datepicker-month-year__arrow datepicker-month-year__arrow--left"></span>
        </button>
        <div class="datepicker-month-year__wrapper">
          <div class="datepicker-month-year__select">
            <select id="${elementId}-month" class="datepicker-month-year__native">
              ${months
                .map(
                  (month, index) =>
                    `<option value="${index + 1}">${month}</option>`
                )
                .join('')}
            </select>
          </div>
          <div class="datepicker-month-year__select">
            <select id="${elementId}-year" class="datepicker-month-year__native">
              ${years
                .map((year) => `<option value="${year}">${year}</option>`)
                .join('')}
            </select>
          </div>
        </div>
        <button type="button" class="datepicker-month-year__nav-button datepicker-month-year__nav-button--next" id="${elementId}-next" title="Next">
          <span class="datepicker-month-year__arrow datepicker-month-year__arrow--right"></span>
        </button>
      </div>
      <div class="datepicker-month-year__actions">
        <button type="button" class="datepicker-month-year__button datepicker-month-year__button--primary" id="${elementId}-accept">
          ${i18n.t('accept')}
        </button>
      </div>
    `;

    return selector;
  };

  let updateDisplay = (elementId, month, year) => {
    const input = document.getElementById(elementId);
    if (input) {
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      input.value = `${formattedMonth} / ${year}`;

      const wrapper = input.parentElement;
      if (
        wrapper &&
        !wrapper.querySelector('.datepicker-month-year__arrow-down')
      ) {
        const arrow = document.createElement('span');
        arrow.className = 'datepicker-month-year__arrow-down';
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        wrapper.appendChild(arrow);
      }
    }
  };

  let showSelector = () => {
    if (selectorElement) {
      selectorElement.style.display = 'block';
    }
  };

  let hideSelector = () => {
    if (selectorElement) {
      selectorElement.style.display = 'none';
    }
  };

  let handlePrevMonth = (elementId) => {
    const monthSelect = document.getElementById(`${elementId}-month`);
    const yearSelect = document.getElementById(`${elementId}-year`);

    if (monthSelect && yearSelect) {
      let month = parseInt(monthSelect.value);
      let year = parseInt(yearSelect.value);

      month--;
      if (month < 1) {
        month = 12;
        year--;
        if (year < 2015) {
          year = 2015;
          month = 1;
        }
      }

      monthSelect.value = month;
      yearSelect.value = year;
    }
  };

  let handleNextMonth = (elementId) => {
    const monthSelect = document.getElementById(`${elementId}-month`);
    const yearSelect = document.getElementById(`${elementId}-year`);

    if (monthSelect && yearSelect) {
      let month = parseInt(monthSelect.value);
      let year = parseInt(yearSelect.value);

      month++;
      if (month > 12) {
        month = 1;
        year++;
        const currentYearValue = new Date().getFullYear();
        if (year > currentYearValue) {
          year = currentYearValue;
          month = 12;
        }
      }

      monthSelect.value = month;
      yearSelect.value = year;
    }
  };

  let handleAccept = (elementId) => {
    const monthSelect = document.getElementById(`${elementId}-month`);
    const yearSelect = document.getElementById(`${elementId}-year`);

    if (monthSelect && yearSelect) {
      const month = parseInt(monthSelect.value);
      const year = parseInt(yearSelect.value);

      currentMonth = month;
      currentYear = year;

      updateDisplay(elementId, month, year);

      hideSelector();

      if (onDateChangeCallback) {
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
        onDateChangeCallback({
          day: '01',
          month: formattedMonth,
          year: year.toString(),
          formatted: `01-${formattedMonth}-${year}`,
        });
      }
    }
  };

  let setupHoyButtonListener = (elementId = 'datepickerMonthYear') => {
    setTimeout(() => {
      const hoyButton = document.querySelector('.ui-datepicker-current');
      if (hoyButton) {
        hoyButton.addEventListener('click', () => {
          setTimeout(() => {
            const today = new Date();
            const newDate = {
              day: String(today.getDate()).padStart(2, '0'),
              month: String(today.getMonth() + 1).padStart(2, '0'),
              year: String(today.getFullYear()),
            };
            updateDate(newDate, elementId);
          }, 100);
        });
      }
    }, 500);
  };

  let initializeDatepicker = (options) => {
    config = options;
    const {
      elementId = 'datepickerMonthYear',
      initialDate,
      onDateChange,
    } = options;

    inputElement = document.getElementById(elementId);
    if (!inputElement) {
      console.error(`Element with id '${elementId}' not found`);
      return;
    }

    onDateChangeCallback = onDateChange;

    currentMonth = parseInt(initialDate.month);
    currentYear = parseInt(initialDate.year);

    updateDisplay(elementId, currentMonth, currentYear);

    selectorElement = createSelector(elementId);
    inputElement.parentElement.appendChild(selectorElement);

    setTimeout(() => {
      const monthSelect = document.getElementById(`${elementId}-month`);
      const yearSelect = document.getElementById(`${elementId}-year`);
      if (monthSelect) monthSelect.value = currentMonth;
      if (yearSelect) yearSelect.value = currentYear;
    }, 0);

    inputElement.addEventListener('click', (e) => {
      e.stopPropagation();
      if (selectorElement.style.display === 'block') {
        hideSelector();
      } else {
        const monthSelect = document.getElementById(`${elementId}-month`);
        const yearSelect = document.getElementById(`${elementId}-year`);
        if (monthSelect) monthSelect.value = currentMonth;
        if (yearSelect) yearSelect.value = currentYear;
        showSelector();
      }
    });

    const acceptButton = document.getElementById(`${elementId}-accept`);
    if (acceptButton) {
      acceptButton.addEventListener('click', (e) => {
        e.stopPropagation();
        handleAccept(elementId);
      });
    }

    const prevButton = document.getElementById(`${elementId}-prev`);
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.stopPropagation();
        handlePrevMonth(elementId);
      });
    }

    const nextButton = document.getElementById(`${elementId}-next`);
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.stopPropagation();
        handleNextMonth(elementId);
      });
    }

    document.addEventListener('click', (e) => {
      if (
        selectorElement &&
        !selectorElement.contains(e.target) &&
        !inputElement.contains(e.target)
      ) {
        hideSelector();
      }
    });

    setupHoyButtonListener(elementId);
  };

  let updateDate = (newDate, elementId = 'datepickerMonthYear') => {
    currentMonth = parseInt(newDate.month);
    currentYear = parseInt(newDate.year);

    updateDisplay(elementId, currentMonth, currentYear);

    const monthSelect = document.getElementById(`${elementId}-month`);
    const yearSelect = document.getElementById(`${elementId}-year`);
    if (monthSelect) monthSelect.value = currentMonth;
    if (yearSelect) yearSelect.value = currentYear;
  };

  let destroy = (elementId = 'datepickerMonthYear') => {
    if (selectorElement && selectorElement.parentElement) {
      selectorElement.parentElement.removeChild(selectorElement);
    }
    selectorElement = null;
    inputElement = null;
    onDateChangeCallback = null;
  };

  return {
    initializeDatepicker,
    updateDate,
    destroy,
  };
})();

export { componentDatepickerMonthYear };
